import React, { FC } from 'react'
import { Navigate, Outlet, Route } from 'react-router-dom'

import {
    Home,
    Village,
    Ranking,
    Deposits,
    VillageSelection,
    VillageClientDetails,
    VillageClient,
    ClientPaymentHistory,
    VillagePrevClientDetails,
    Calcapp,
    Visit,
    GPSWarning,
    ClientSearch,
    ClientSearchResult,
    Profile,
    Notification,
    CardInventory,
    MobileMoney,
    BulkEnrollmentPackageSelection,
    BulkEnrollmentEntry,
    BulkEnrollmentConfirmation,
    BulkEnrollmentLayout
} from '../../pages'
import EnrollmentBase from 'pages/enrollment/v3/EnrollmentBase'

const ConnectRoutes = () => {
    const HomePage = Home as FC
    const VillagePage = Village as FC
    const VillagePrevClientDetailsPage = VillagePrevClientDetails as FC

    return (
        <Route path="/" element={<Outlet />}>
            <Route path="/" element={<Navigate replace to="home" />} />
            <Route path="home" element={<HomePage />} />
            <Route path="home" element={<Outlet />}>
                <Route path="ranking" element={<Ranking />} />
            </Route>
            <Route path="home" element={<Outlet />}>
                <Route path="deposits" element={<Deposits />} />
            </Route>
            <Route path="village" element={<VillagePage />} />
            <Route path="village" element={<Outlet />}>
                <Route path="select-village" element={<VillageSelection />} />
                <Route path=":villageId" element={<VillageClient />} />
                <Route path=":villageId" element={<Outlet />}>
                    <Route path="bulk-enrollment" element={<BulkEnrollmentLayout />}>
                        <Route
                            path="packages"
                            element={<BulkEnrollmentPackageSelection />}
                        />
                        <Route path="entry" element={<BulkEnrollmentEntry />} />
                        <Route
                            path="confirmation"
                            element={<BulkEnrollmentConfirmation />}
                        />
                    </Route>
                    <Route
                        path="client/:clientId"
                        element={<VillageClientDetails />}
                    />
                    <Route path="client/:clientId" element={<Outlet />}>
                        <Route
                            path="payment-history"
                            element={<ClientPaymentHistory />}
                        />
                        <Route path="previous" element={<Outlet />}>
                            <Route
                                index
                                element={<VillagePrevClientDetailsPage />}
                            />
                            <Route
                                path="payment-history"
                                element={<ClientPaymentHistory />}
                            />
                        </Route>
                    </Route>
                </Route>
            </Route>
            <Route path="calcapp" element={<Calcapp />} />
            <Route path="gpswarning" element={<GPSWarning />} />
            <Route path="visit" element={<Visit />} />
            <Route path="client-search" element={<ClientSearch />} />
            <Route path="client-search" element={<Outlet />}>
                <Route path="result" element={<ClientSearchResult />} />
            </Route>
            <Route path="notification" element={<Outlet />}>
                <Route path="messages" element={<Notification />} />
            </Route>
            <Route path="/enroll/:villageId" element={<EnrollmentBase />} />
            <Route
                path="farmer-id"
                element={<Navigate replace to="/client-search" />}
            />
            <Route path="profile" element={<Profile />} />
            <Route path="profile" element={<Outlet />}>
                <Route path="deposits" element={<Deposits />} />
            </Route>
            <Route path="card-inventory" element={<CardInventory />} />
            <Route path="mobile-money" element={<Outlet />}>
                <Route path="payment" element={<MobileMoney />} />
            </Route>
        </Route>
    )
}

export default ConnectRoutes
